import React, { Component } from 'react';
import { Grid, Checkbox, TextField, TextareaAutosize, FormControl, FormHelperText, Box, FormControlLabel, Switch, InputAdornment } from '@mui/material';


import PhoneNumber from 'Components/PhoneNumber';
import { validateMobileNumber, validateDate, validateMobileNumberFormat } from 'Includes/functions';
import { Dropdown } from 'Components/DropDown';
import { DropDownWithSearch } from 'Components/DropDownWithSearch';
import classNames from 'classnames'
import { getRequest } from 'Includes/api/apicall';
import './styles.scss'
import commonMessages from 'Constants/messages'

export default class index extends Component {
    constructor(props) {
        super(props)

        this.state = {
            fieldErrors: {},
            list: [],
            inputValue: '',
            loadingChild: {}
        }
    }

    componentDidMount = () => {
        this.setDefaultValues();
    }

    setDefaultValues = () => {
        let field = this.state
        let { fieldErrors, list } = this.state
        const { fieldDetails } = this.props;
        fieldDetails.map((fields) => {
            field[fields.name] = fields.default ? fields.default : '';
            fieldErrors[fields.name] = '';
            if (fields.type === 'dropDownWithGetRequest' || fields.type === 'dropDownWithSearchAndGetRequest') {
                list[fields.name] = fields.list ? fields.list : []
            }
        })
        this.setState({ ...field, fieldErrors, list });
    }
    handleSearchChange = (e, field) => {
        let { fieldErrors } = this.state
        let value = e;
        let name = field.name;
        const { state } = this
        fieldErrors[name] = '';
        if (field.type === 'text' || field.type === 'text_area') {
            value = e.target.value.replace(/  +/g, ' ');
        }
        if (field.type === 'number') {
            value = e.target.value;
            if (value === '') {
                if (field.required) {
                    fieldErrors[name] = 'This field is Mandatory';
                }
            }
            if (value > field.maxNumber) {
                return
            }

        }
        if (field.type === 'dropDown') {
            value = e.target.value;
            this.props.updateParent(name, value)
        }
        if (field.type === 'date') {
            value = e && e.target ? e.target.value : ''
            if (value === '') {
                if (field.required) {
                    fieldErrors[name] = 'This field is Mandatory';
                }
            }
            else {
                this.props.updateParent(name, value)
            }
        }
        if (field.type === "checkbox" || field.type === 'switch' || field.type === 'radio') {
            value = !this.state[name];
            this.props.updateParent(name, value)
            if (field.dependentChildren && !value) {
                field.dependentChildren.map((data) => {
                    this.props.updateParent(data, null)
                    this.setState({
                        [data]: null
                    })
                })
            }
        }
        this.setState({
            [name]: value,
            fieldErrors,
        })

    }

    changeInParent = (e, field) => {
        let { fieldErrors } = this.state
        const { state } = this
        let value = typeof (state[field.name]) === 'string' ?  state[field.name].trim() :state[field.name]
        let name = field.name;
        if (field.type === 'phone_number') {
            let returnValue = validateMobileNumber(field, value)
            if (!returnValue.test) {
                fieldErrors[name] = returnValue.error
            }
            else {
                value = returnValue.value
            }
        }
        // Custom validation for contactPersonPhoneno using validateMobileNumberFormat
        else if (name === 'contactPersonPhoneno') {
            const phoneValidation = validateMobileNumberFormat(value, field.required || false);
            if (!phoneValidation.isValid) {
                fieldErrors[name] = phoneValidation.error;
            } else {
                // Clear error if validation passes
                if (fieldErrors[name]) {
                    delete fieldErrors[name];
                }
            }
        }
        else if (field.required && (value === '' || value === null || value === 0)) {
            fieldErrors[name] = 'This field is Mandatory';
        }
        else if (field.regex && !field.regex.value.test(value) && value !== '') {
            fieldErrors[name] = field.regex.errorText;
        }
        if (field.type === 'date') {
            if (e === null) {
                value = ''
            }
        }
        this.setState({
            fieldErrors,
            [name]: value,
        }, () => {
            this.props.updateParent(name, value)
        })
    }

    onBlurDateValidation = (field) => {
        let { fieldErrors } = this.state
        const { state } = this
        let value = state[field.name]
        let name = field.name;
        if (name && name.indexOf('order_date') !== -1) {
            const isValid = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);
            if (value === '' && field.required) {
                fieldErrors[name] = 'This field is Mandatory';
            }
            else if (value !== '' && !isValid) {
                fieldErrors[name] = 'Invalid Date';
            }
            else {
                this.props.updateParent(name, value)
            }
            this.setState({ fieldErrors })
            return;
        }
        // Check minDate and maxDate constraints
        if (field.minDate && value && value < field.minDate) {
            fieldErrors[name] = `Date must be on or after ${field.minDate}`;
            this.setState({ fieldErrors });
            return;
        }
        if (field.maxDate && value && value > field.maxDate) {
            fieldErrors[name] = `Date must be on or before ${field.maxDate}`;
            this.setState({ fieldErrors });
            return;
        }
        let minDate = field.parentMinDate ? state[field.parentMinDate] : field.minDate;
        let maxDate = field.maxDate;
        let error = validateDate(value, minDate, maxDate)
        if (value === '' && field.required) {
            fieldErrors[name] = 'This field is Mandatory';
        }
        else {
            if (error !== '') {
                fieldErrors[name] = error
                if (value === '' && !field.required) {
                    fieldErrors[name] = ''
                }
            }
            else {
                this.props.updateParent(name, value)
            }
        }
        this.setState({ fieldErrors })
    }

    updateErrors = (fieldErrors) => {
        this.setState({
            fieldErrors: fieldErrors
        })
    }

    handleChangeGetRequest = (e, field) => {
        let { fieldErrors, list, loadingChild } = this.state
        let value = e.target.value;
        let name = field.name;
        fieldErrors[name] = '';
        if (field.requestURL) {
            loadingChild[field.updateListTo] = true
            list[field.updateListTo] = []
            this.setState({
                [field.updateListTo]: null,
                loadingChild,
                list
            })
            let url = ''
            let param = {}
            if (field.requestType == 'dummyParam') {
                url = `${field.requestURL}${value}/`
                field.params.map((data) => {
                    param[data] = 1
                })
            }
            else {
                url = field.requestURL
                field.params.map((data) => {
                    param[data] = value
                })
            }
            getRequest(url, param, this.props).then(response => {
                if (response && response.status === 200) {
                    list[field.updateListTo] = response.data.data
                    loadingChild[field.updateListTo] = false
                    this.setState({
                        list,
                        loadingChild
                    })
                }
            })
        }
        field['list'] = list[field.name]
        this.props.updateParent(name, value, list)
        this.setState({
            [name]: value,
            fieldErrors,
        })
    }

    handleDropDownSearchChangeGetRequest = (e, value, field) => {
        let { fieldErrors, list } = this.state
        let name = field.name;
        fieldErrors[name] = '';
        if (field.requestURL) {
            let url = ''
            let param = {}
            if (field.requestType == 'dummyParam') {
                url = `${field.requestURL}${value}/`
                field.params.map((data) => {
                    param[data] = 1
                })
            }
            else {
                url = field.requestURL
                field.params.map((data) => {
                    param[data] = value
                })
            }
            getRequest(url, param, this.props).then(response => {
                if (response && response.status === 200) {
                    list[field.updateListTo] = response.data.data
                    this.setState({
                        list,
                    })
                }
            })
        }
        field['list'] = list[field.name]
        this.props.updateParent(name, value, list)
        this.setState({
            [name]: value,
            fieldErrors,
        })
    }

    handleDropDownSearchChange = (e, newValue, field) => {
        let { fieldErrors } = this.state
        let name = field.name;
        fieldErrors[name] = '';
        let value = newValue;
        this.setState({
            [name]: value,
            fieldErrors
        })
        this.props.updateParent(name, value)
    }

    render() {
        const { fieldDetails, loading, containerSpacing, externalErrors = {} } = this.props
        const { fieldErrors, list, inputValue, loadingChild } = this.state
        const { state } = this
        // Merge external errors with internal errors (external takes precedence)
        const mergedFieldErrors = { ...fieldErrors, ...externalErrors };
        return (
            <Grid container spacing={containerSpacing ? containerSpacing : 2}>
                {
                    fieldDetails.map((field, index) => {
                        let customHelperText = mergedFieldErrors[field.name] ? mergedFieldErrors[field.name] : (!state[field.name] && field.helperText) ||
                            (state[field.parentValue] && state[field.parentValue] !== '' ? field.parentHelperText && field.parentHelperText : '')
                        let className = customHelperText ? 'mt-10' : 'mv-10';
                        className = (field.gridClassName) ? `${field.gridClassName} ${className}` : className;
                        return !field.hidden && ((field.dependentParent && state[field.dependentParent]) || (!field.dependentParent && !state[field.dependentParent])) &&
                            <Grid item md={field.md} key={field.value} xs={12} sm={12} className={className}>
                                {(field.type === 'text' || field.type === 'multiline-text') &&
                                    <TextField
                                        id={field.id}
                                        label={field.label}
                                        autoComplete="off"
                                        required={field.required}
                                        name={field.name}
                                        value={state[field.name]}
                                        className={field.className}
                                        inputProps={{ maxLength: field.maxLength }}
                                        fullWidth={field.className ? false : true}
                                        disabled={field.disabled || state[field.parentValue] ? state[field.parentValue] !== '' : false}
                                        rows={field.rows}
                                        variant="outlined"
                                        helperText={customHelperText}
                                        error={mergedFieldErrors[field.name] && (mergedFieldErrors[field.name] === "" ? false : true)}
                                        onChange={(e) => this.handleSearchChange(e, field)}
                                        onBlur={(e) => this.changeInParent(e, field)}
                                    />}
                                {(field.type === 'number') && <TextField
                                    id={field.id}
                                    label={field.label}
                                    required={field.required}
                                    type={field.type}
                                    name={field.name}
                                    value={state[field.name]}
                                    className={field.className}
                                    inputProps={{
                                        min: field.minNumber !== undefined ? field.minNumber : undefined,
                                        max: field.maxNumber !== undefined ? field.maxNumber : undefined,
                                    }}
                                    InputProps={field.endAdornment ? {
                                        endAdornment: (
                                            <InputAdornment position="end">{field.endAdornment}</InputAdornment>
                                        ),
                                    } : undefined}
                                    fullWidth={field.className ? false : true}
                                    disabled={field.disabled || state[field.parentValue] ? state[field.parentValue] !== '' : false}
                                    rows={field.rows}
                                    variant="outlined"
                                    helperText={mergedFieldErrors[field.name] === "" ?
                                        field.helperText ||
                                        (state[field.parentValue] && state[field.parentValue] !== '' ? field.parentHelperText && field.parentHelperText : '')
                                        : mergedFieldErrors[field.name]}
                                    error={mergedFieldErrors[field.name] && (mergedFieldErrors[field.name] === "" ? false : true)}
                                    onChange={(e) => this.handleSearchChange(e, field)}
                                    onBlur={(e) => this.changeInParent(e, field)}
                                />}
                                {field.type === 'date' &&
                                    <TextField
                                        className={classNames(field.className)}
                                        type="date"
                                        variant="outlined"
                                        label={field.label}
                                        name={field.name}
                                        InputLabelProps={{ shrink: true }}
                                        value={state[field.name] ? state[field.name] : ''}
                                        disabled={field.parentMinDate ? state[field.parentMinDate] ? false : true : field.disabled}
                                        required={field.required}
                                        onChange={(e) => this.handleSearchChange(e, field)}
                                        onBlur={() => this.onBlurDateValidation(field)}
                                        helperText={mergedFieldErrors[field.name] === "" ? field.helperText : mergedFieldErrors[field.name]}
                                        error={mergedFieldErrors[field.name] && (mergedFieldErrors[field.name] === "" ? false : true)}
                                        inputProps={{
                                            min: field.minDate || undefined,
                                            max: field.maxDate || undefined,
                                        }}
                                    />
                                }
                                {field.type === 'phone_number' &&
                                    <PhoneNumber
                                        label={field.label}
                                        className={field.className}
                                        required={field.required}
                                        value={state[field.name]}
                                        name={field.name}
                                        error={mergedFieldErrors[field.name]}
                                        onChange={e => this.handleSearchChange(e, field)}
                                        helperText={mergedFieldErrors[field.name] === "" ? field.helperText : mergedFieldErrors[field.name]}
                                        onBlur={(e) => this.changeInParent(e, field)}
                                    />
                                }
                                {field.type === 'dropDown' && state[field.name] !== undefined && !loading &&
                                    <Dropdown
                                        data={field.list}
                                        name={field.name}
                                        value={state[field.name]}
                                        onChange={(e) => this.handleSearchChange(e, field)}
                                        error={mergedFieldErrors[field.name]}
                                        label={field.label}
                                        style={field.className}
                                        disabled={field.disabled}
                                        required={field.required}
                                        multiple={field.multiple}
                                        hideSelect={field.required ? true : field.hideSelect}
                                    />}
                                {field.type === 'dropDownWithGetRequest' && state[field.name] !== undefined && !loading &&
                                    <Dropdown
                                        data={list[field.name]}
                                        name={field.name}
                                        value={state[field.name]}
                                        onChange={(e) => this.handleChangeGetRequest(e, field)}
                                        error={mergedFieldErrors[field.name]}
                                        label={field.label}
                                        style={field.className}
                                        disabled={field.parent ? state[field.parent] ? false : true : field.disabled}
                                        required={field.required}
                                        helperText={field.parent ? state[field.parent] ? false : field.helperText : ''}
                                        hideSelect={field.required ? true : field.hideSelect}
                                    />}
                                {field.type === "checkbox" && state[field.name] !== undefined && !loading && (
                                    <Box>
                                        <Checkbox
                                            onChange={(e) => this.handleSearchChange(e, field, index)}
                                            color="primary"
                                            name={field.name}
                                            checked={state[field.name]}
                                            inputProps={{
                                                "aria-label": "primary checkbox",
                                            }}
                                        />
                                        <span>{field.label}</span>
                                    </Box>
                                )}
                                {field.type === 'dropDownWithSearch' && state[field.name] !== undefined && !loading &&
                                    <DropDownWithSearch
                                        id="combo-box-demo"
                                        options={field.list}
                                        value={state[field.name]}
                                        optionValue={field.optionValue}
                                        onChange={(e, newValue) => this.handleDropDownSearchChange(e, newValue, field)}
                                        name={field.name}
                                        label={field.label}
                                        className={field.className}
                                        required={field.required}
                                        error={mergedFieldErrors[field.name]}
                                        disabled={field.parent ? state[field.parent] ? false : true : field.disabled}
                                        helperText={mergedFieldErrors[field.name] ? mergedFieldErrors[field.name] : field.helperText}
                                        hideClearIcon={field.hideClearIcon}
                                    />
                                }
                                {field.type === 'dropDownWithSearchAndGetRequest' && state[field.name] !== undefined && !loading &&
                                    <DropDownWithSearch
                                        id="combo-box-demo"
                                        options={list[field.name]}
                                        value={state[field.name]}
                                        optionValue={field.optionValue}
                                        onChange={(e, newValue) => this.handleDropDownSearchChangeGetRequest(e, newValue, field)}
                                        name={field.name}
                                        className={field.className}
                                        error={mergedFieldErrors[field.name]}
                                        label={field.label}
                                        disabled={field.parent ? state[field.parent] ? false : true : field.disabled}
                                        required={field.required}
                                        helperText={field.parent ? state[field.parent] ? false : field.helperText : ''}
                                        loadingValue={loadingChild[field.name] ? loadingChild[field.name] : false}
                                    />
                                }
                                {field.type === 'text_area' &&
                                    <FormControl
                                        fullWidth
                                        error={mergedFieldErrors[field.name] && (mergedFieldErrors[field.name] ? true : false)}
                                    >
                                        <Box className='apply-leave-label-names'>{field.required ? `${field.label} *`: field.label}</Box>
                                        <TextareaAutosize aria-label="minimum height"
                                            className='apply-leave-text-area-auto-size-reason'
                                            value={state[field.name]}
                                            maxLength={field.maxLength}
                                            name={field.name}
                                            required={field.required}
                                            minRows={field.rows || 2}
                                            onChange={(e) => this.handleSearchChange(e, field)}
                                            onBlur={(e) => this.changeInParent(e, field)}
                                        />
                                        {mergedFieldErrors[field.name] &&
                                            <FormHelperText>{mergedFieldErrors[field.name]}</FormHelperText>
                                        }
                                    </FormControl>

                                }
                                {field.type === 'switch' && state[field.name] !== undefined && !loading &&
                                    <FormControlLabel
                                        control={<Switch checked={state[field.name]}
                                            name={field.name}
                                            value={state[field.name]}
                                            color="primary"
                                            onChange={(e) => this.handleSearchChange(e, field)} />}
                                        label={field.label}
                                    />
                                }
                                {field.type === 'radio' && state[field.name] !== undefined && !loading &&
                                    <div>
                                        {field.label}
                                        {field.radioOptions.map((data) => {
                                            return (
                                                <Box>
                                                    <label>
                                                        <input type='radio' value={data.value} name={field.name}
                                                            checked={state[field.name] == data.value}
                                                            defaultChecked={state[field.name] == data.value}
                                                            onChange={(e) => this.handleSearchChange(e, field)} /> {data.label}
                                                    </label>
                                                </Box>
                                            )
                                        })}
                                    </div>
                                }
                            </Grid>
                    }
                    )
                }
            </Grid>
        )
    }
}
